import { render, staticRenderFns } from "./productTagsCom.vue?vue&type=template&id=dbbb0d40&scoped=true"
import script from "./productTagsCom.vue?vue&type=script&lang=js"
export * from "./productTagsCom.vue?vue&type=script&lang=js"
import style0 from "./productTagsCom.vue?vue&type=style&index=0&id=dbbb0d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbb0d40",
  null
  
)

export default component.exports